window.jk = window.jk || {};

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.details = this.querySelector('details');
    if (window.matchMedia('(hover: hover)').matches) {
      this.details.addEventListener('mouseenter', () => (this.details.open = true));
      this.details.addEventListener('mouseleave', () => (this.details.open = false));
    }
  }

  connectedCallback() {
    this.hasAttributes('mega-menu') && this.setupMegaGroup();
  }

  onToggle() {
    if (!this.header) return;

    if (!this.animations) this.animations = this.content.getAnimations({ subtree: true });
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );

    if (this.megaMenu) {
      const detail = this.detailsList.find((detail) => detail.open);
      if (detail) {
        this.megaGroup.style = `--sdb-content-height:${detail.querySelector('.sidebar-mega_menu-content').offsetHeight}px`;
      }
    }
  }

  setupMegaGroup() {
    this.megaMenu = true;
    this.megaGroup = this.querySelector('.sidebar-mega_menu');
    this.detailsList = Array.from(this.megaGroup.querySelectorAll('details'));
    this.detailsList.forEach((detail) => {
      detail.addEventListener('mouseenter', () => (detail.open = true));
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        const height = detail.querySelector('.sidebar-mega_menu-content').offsetHeight;
        this.megaGroup.style = `--sdb-content-height:${height}px`;
        this.detailsList.forEach((details) => details !== detail && (details.open = false));
      });
      detail.querySelector('summary')?.addEventListener('click', (e) => detail.open && e.preventDefault());
    });
  }
}

customElements.define('header-menu', HeaderMenu);

window.jk.Accordion = class {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(evt) {
    evt.preventDefault();
    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }
  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      },
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }
  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = '';
  }
};

document.querySelectorAll('.accordion details').forEach((details) => {
  new window.jk.Accordion(details);
});
